import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalBasicsByIdInput,
  terminalBasicsByIdInputSchema,
} from "./shared/terminalBasics.input";
import {
  type TerminalBasic,
  terminalBasicSchema,
} from "./shared/terminalBasics.output";

/**
 * Metadata for the fetchTerminalBasicsByTerminalId endpoint
 */
export const terminalBasicsByTerminalIdMeta = {
  functionName: "fetchTerminalBasicsByTerminalId",
  endpoint: "/terminalBasics/{TerminalID}",
  inputSchema: terminalBasicsByIdInputSchema,
  outputSchema: terminalBasicSchema,
  sampleParams: { TerminalID: 1 },
  endpointDescription: "Get basic information for a specific terminal by ID.",
} satisfies EndpointMeta<TerminalBasicsByIdInput, TerminalBasic>;

/**
 * Fetch function for retrieving basic information for a specific terminal by ID
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalBasicsByIdInput,
  TerminalBasic
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalBasicsByTerminalIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalBasics.endpoints").terminalBasicsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving basic information for a specific terminal by ID
 */
export const fetchTerminalBasicsByTerminalId: FetchFactory<
  TerminalBasicsByIdInput,
  TerminalBasic
> = fetch;

/**
 * React Query hook for retrieving basic information for a specific terminal by ID
 */
export const useTerminalBasicsByTerminalId: HookFactory<
  TerminalBasicsByIdInput,
  TerminalBasic
> = useHook;
